import styles from '../AdminPortal.module.scss';
import { TpOrganizationInfo, TpOrganizationUserInfo, TpPluginInfo } from '../../../api/models/admin';

interface TpOrganizationDetailsProps {
  organization: TpOrganizationInfo;
  plugins: TpPluginInfo[];
  listUsers?: boolean;
}

const OrganizationDetails = (props: TpOrganizationDetailsProps) => {
  const { organization, plugins, listUsers } = props;

  return (
    <div className={styles.organizationDetailBlock}>
      {plugins.length > 0 && organization.pluginIds && organization.pluginIds?.length > 0 && (
        <div className={styles.organizationDetailItem}>
          <span className={styles.organizationName}>Enabled Plugins: </span>
          <ul>
            {organization.pluginIds?.map((pluginId: string) => {
              if (plugins) {
                const plugin = plugins.find((plg) => plg.identifier === pluginId);
                if (plugin) {
                  return <li key={pluginId}>{plugin.prettyName}</li>;
                } else {
                  return <li key={pluginId}>{pluginId}</li>;
                }
              }
            })}
          </ul>
        </div>
      )}
      {listUsers && (
        <div className={styles.organizationDetailItem}>
          <span className={styles.organizationName}>Users: </span>
          <ul>
            {organization.users?.map((usr: TpOrganizationUserInfo) => (
              <li key={usr.userId}>{usr.email}</li>
            ))}
          </ul>
        </div>
      )}
      <div className={styles.organizationDetailItem}>
        <span className={styles.organizationName}>Bucket Prefix: </span>
        {organization.organizationPrefix}
      </div>
      <div className={styles.organizationDetailBlockFiller}></div>
    </div>
  );
};

export default OrganizationDetails;
